// extracted by mini-css-extract-plugin
module.exports = {"tabCardContainer":"DescriptionAndDisclosureContentView_tabCardContainer__1OZOu"};